import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=462b7730&scoped=true&"
import script from "./SearchResult.vue?vue&type=script&lang=ts&"
export * from "./SearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=462b7730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b7730",
  null
  
)

export default component.exports